

interface ProfileCompletionModalProps {
  isOpen: boolean
  onClose: () => void
}

export function ProfileCompletionModal({ isOpen, onClose }: ProfileCompletionModalProps) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg max-w-md w-full p-6 shadow-xl">
        <div className="text-center">
          {/* Icon */}
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 mb-4">
            <svg className="h-6 w-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          </div>

          {/* Title */}
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            Complete Your Profile
          </h3>

          {/* Message */}
          <p className="text-sm text-gray-500 mb-6">
            To access the full features of Contrarian OS, please complete your profile with all required information. This helps us provide you with a personalized experience.
          </p>

          {/* Button */}
          <button
            onClick={onClose}
            className="w-full inline-flex justify-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
          >
            OK, I understand
          </button>
        </div>
      </div>
    </div>
  )
} 